import React from 'react';
import styled from 'styled-components';
import Button from '../buttons/PatternsButton';

const CenteredPatternButton = ({handleClick}) => {
    const StyledCenteredPatternButton = styled.div`
        display: flex;
        justify-content: center;
    `;

    return (
        <StyledCenteredPatternButton>
            <Button handleClick={handleClick} />
        </StyledCenteredPatternButton>
    );
};

export default CenteredPatternButton;



// WEBPACK FOOTER //
// ./src/components/sewpat/CenteredPatternButton.js